import type { GeneralParameters } from '../../general/parameters/general'
import type { FavoriteRemoveParameters } from '../parameters/favorite-remove'

import { Analytix } from '~/shared/analytix'
import { AnalytixEvent } from '../../general/event'
import { Gate, seeds } from '../../general/gate'
import { parameters } from '../parameters/favorite-remove'

/**
 * Event wrapper for `favorite_remove`.
 * Uses session gate to prevent pre-session delivery.
 */
export class FavoriteRemoveEvent extends AnalytixEvent<FavoriteRemoveParameters> {
  name = 'favorite_remove'
  group = 'favorite'
  parameters = parameters
  sender = Analytix.prototype.sendFavoriteRemoveEvent

  // `favorite_remove` event uses session gate to ensure that it is not emitted before session is started
  gates = [Gate.Uses(seeds.session)]

  constructor() {
    super()
    this.verify()
  }

  validate(): false | [GeneralParameters, FavoriteRemoveParameters] {
    return [
      Object.fromEntries(this.general),
      Object.fromEntries(this.parameters),
    ]
  }
}
